module.exports = __webpack_public_path__ + "assets/00ac135abf61b0aaa858371d8795c373.png";